import React, { useState, useEffect, useContext } from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import { MessageContext } from './Contexts'
import NotificationBar from './NotificationBar'
import { updateOperation, newOperation } from 'modules/Utils'
import { onLoggedOut } from 'modules/AppEvents'

const findIndex = (operations, operation_id) =>
  operations.findIndex(operation => operation.operation_id === operation_id)

export const Reducer = (state, action) => {
  switch (action.type) {
    case 'warning':
      if (action.loggedOut || action.payload?.loggedOut || action.payload === 'logged out') return state
      return { ...state, flash: {...action, payload: action.payload ? action.payload : 'An error occurred'} }
    case 'info':
      return { ...state, flash: action }
    case 'clear flash':
      return { ...state, flash: null }
    case 'create operation':
      return {
        ...state,
        operations: [...state.operations, newOperation(action.payload)],
      }
    case 'modify operation':
      const index = findIndex(state.operations, action.payload.operation_id)
      let newState = { ...state }
      newState.operations[index] = updateOperation(newState.operations[index], action.payload)
      return newState
    case 'remove operation':
      const removeIndex = findIndex(state.operations, action.payload.operation_id)
      let newOperations = [...state.operations]
      newOperations.splice(removeIndex, 1)
      return { ...state, operations: newOperations }
    default:
      throw new Error()
  }
}

export default function MessageService() {
  const [flashBarOpen, setFlashBarOpen] = useState(false)
  const { messageState, messageDispatch } = useContext(MessageContext)

  useEffect(() => {
    // handle open/close state of flashBar based on state of messageState.flash
    setFlashBarOpen(!!messageState.flash)
  }, [messageState.flash])

  useEffect(() => {
    // When Rest.js detects logged_in === false, show a persistent warning with
    // a link to log in again.
    const cleanup = onLoggedOut((message) => {
      messageDispatch({
        type: 'warning',
        persistent: true,
        payload: (
          <>
            <div>{message}</div>
            <a href='/' style={{ color: 'inherit', display: 'block', fontWeight: 600, marginTop: 8, textDecoration: 'underline' }}>
              Go to Log In
            </a>
          </>
        ),
      })
    })
    return cleanup
  }, [messageDispatch])

  const clearFlash = () => {
    setFlashBarOpen(false)
    messageDispatch({ type: 'clear flash' })
  }

  return (
    <>
      <Snackbar
        open={flashBarOpen}
        autoHideDuration={messageState.flash?.persistent ? null : 6000}
        onClose={clearFlash}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {messageState.flash && (
          <MuiAlert
            elevation={6}
            variant='filled'
            severity={messageState.flash.type}
            onClose={clearFlash}
          >
            {<div style={{whiteSpace: 'pre-line'}}>{messageState.flash.payload}</div>}
          </MuiAlert>
        )}
      </Snackbar>
      <NotificationBar notifications={messageState.operations} />
    </>
  )
}
